(function () {
  function getVariantLabel(variant) {
    const source = (variant && (variant.option1 || variant.title || '')) || '';
    const lower = source.toLowerCase();
    if (lower.includes('dual')) return 'ADD DUAL GRIP TO CART';
    if (lower.includes('single')) return 'ADD SINGLE GRIP TO CART';
    return 'ADD TO CART';
  }

  function formatLabel(variant) {
    if (!variant) return 'ADD TO CART';
    const base = getVariantLabel(variant);
    return variant.price_money ? `${base} — ${variant.price_money}` : base;
  }

  function formatStickyLabel(variant) {
    if (!variant) return 'ADD TO CART';
    const source = ((variant.option1 || variant.title || '') + '').toLowerCase();
    let base = 'ADD TO CART';
    if (source.includes('dual')) base = 'ADD DUAL';
    else if (source.includes('single')) base = 'ADD SINGLE';
    return variant.price_money ? `${base} — ${variant.price_money}` : base;
  }

  function parseVariants(node) {
    if (!node) return [];
    try {
      return JSON.parse(node.textContent.trim());
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  function getVariantsList() {
    const heroJson = document.querySelector('[data-isol8-variants-json]');
    if (heroJson) return parseVariants(heroJson);
    const stickyJson = document.querySelector('[data-isol8-sticky-variants]');
    if (stickyJson) return parseVariants(stickyJson);
    return [];
  }

  function getMainVariantInput() {
    return document.querySelector('product-form form input[name="id"].product-variant-id, product-form form input[name="id"]');
  }

  function getMainSubmit() {
    return document.querySelector('product-form .product-form__submit');
  }

  function setMainVariantId(variantId) {
    const input = getMainVariantInput();
    if (!input || !variantId) return;
    input.value = String(variantId);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncVariantButtons(variant) {
    if (!variant) return;
    const value = variant.option1 || '';
    document.querySelectorAll('.variant-btn').forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.value === value);
    });
  }

  function updateHeroCta(variant) {
    const titleEl = document.querySelector('[data-isol8-hero-cta-label]');
    if (titleEl) titleEl.textContent = formatLabel(variant);

    const trialBtn = document.querySelector('[data-isol8-hero-atc]');
    if (trialBtn) {
      trialBtn.disabled = !(variant && variant.available);
    }

    const submitText = document.querySelector('product-form .product-form__submit-text');
    if (submitText && variant) {
      submitText.textContent = formatLabel(variant);
    }
  }

  function updateStickyCta(root, variant) {
    if (!root || !variant) return;
    const priceEl = root.querySelector('[data-isol8-sticky-price]');
    const labelEl = root.querySelector('[data-isol8-sticky-atc-label]');
    const button = root.querySelector('[data-isol8-sticky-atc]');
    const select = root.querySelector('[data-isol8-sticky-select]');
    const thumb = root.querySelector('.isol8-sticky-atc__thumb');

    if (priceEl && variant.price_money) priceEl.textContent = variant.price_money;
    if (labelEl) labelEl.textContent = formatStickyLabel(variant);
    if (button) button.disabled = !variant.available;
    if (select && String(select.value) !== String(variant.id)) {
      select.value = String(variant.id);
    }
    if (thumb && variant.featured_image) {
      thumb.src = variant.featured_image;
    }
  }

  function findVariant(variants, variantId) {
    return variants.find((variant) => String(variant.id) === String(variantId));
  }

  function findVariantByKey(variants, key) {
    const needle = (key || '').toLowerCase();
    if (!needle || needle === 'current') return null;
    return variants.find((item) => {
      const source = ((item && (item.option1 || item.title)) || '').toLowerCase();
      return source.includes(needle);
    }) || null;
  }

  function resolveClosingVariant(btn, variants, currentVariant) {
    const key = (btn.getAttribute('data-isol8-closing-variant') || 'current').toLowerCase();
    if (key === 'current') return currentVariant;
    return findVariantByKey(variants, key) || currentVariant;
  }

  function updateClosingCta(currentVariant) {
    const variants = getVariantsList();
    document.querySelectorAll('[data-isol8-closing-atc]').forEach((btn) => {
      const target = resolveClosingVariant(btn, variants, currentVariant);
      const label = btn.querySelector('[data-isol8-closing-atc-label]');
      if (label && target) label.textContent = formatLabel(target);
      if (target && !target.available) {
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('aria-disabled');
      }
    });
  }

  function setShopifyChatStickyOffset(enabled) {
    const chats = document.querySelectorAll('shopify-chat');
    chats.forEach((chat) => {
      const root = chat.shadowRoot;
      if (!root) return;
      let style = root.querySelector('style[data-isol8-sticky-offset]');
      if (!style) {
        style = document.createElement('style');
        style.setAttribute('data-isol8-sticky-offset', '1');
        root.appendChild(style);
      }
      // Only nudge (same bottom as Smile Rewards). Do not offset wrapper — that double-lifts.
      style.textContent = enabled
        ? '.activator-nudge{bottom:92px!important;}'
        : '';
    });
  }

  function syncFloatingWidgetsWithSticky(root) {
    const visible = !!(root && root.classList.contains('is-visible'));
    setShopifyChatStickyOffset(visible);
  }

  function initStickyBar(root) {
    if (root.dataset.isol8Bound === 'true') return;
    root.dataset.isol8Bound = 'true';

    const variants = parseVariants(root.querySelector('[data-isol8-sticky-variants]'));
    const select = root.querySelector('[data-isol8-sticky-select]');
    const button = root.querySelector('[data-isol8-sticky-atc]');
    const hero = document.querySelector('#shopify-section-main, product-info');

    const applyVariant = (variantId) => {
      const variant = findVariant(variants, variantId) || variants.find((item) => item.available) || variants[0];
      if (!variant) return;
      setMainVariantId(variant.id);
      syncVariantButtons(variant);
      updateHeroCta(variant);
      updateStickyCta(root, variant);
      updateClosingCta(variant);
    };

    if (select) {
      select.addEventListener('change', () => applyVariant(select.value));
    }

    if (button) {
      button.addEventListener('click', () => {
        const submit = getMainSubmit();
        if (submit && !submit.disabled) submit.click();
      });
    }

    const currentInput = getMainVariantInput();
    applyVariant(currentInput ? currentInput.value : (select && select.value));

    const toggleVisibility = () => {
      if (!hero) {
        root.classList.add('is-visible');
        syncFloatingWidgetsWithSticky(root);
        return;
      }
      const rect = hero.getBoundingClientRect();
      const passedHero = rect.bottom < 80;
      root.classList.toggle('is-visible', passedHero);
      syncFloatingWidgetsWithSticky(root);
    };

    toggleVisibility();
    window.addEventListener('scroll', toggleVisibility, { passive: true });
    window.addEventListener('resize', toggleVisibility);

    // Chat widget may load late — re-apply offset when shopify-chat appears
    const chatObserver = new MutationObserver(() => syncFloatingWidgetsWithSticky(root));
    chatObserver.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => syncFloatingWidgetsWithSticky(root), 800);
    setTimeout(() => syncFloatingWidgetsWithSticky(root), 2000);

    document.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLInputElement)) return;
      if (event.target.name !== 'id') return;
      if (!event.target.closest('product-form')) return;
      applyVariant(event.target.value);
    });
  }

  function initHeroFramework() {
    const heroRoot = document.querySelector('[data-isol8-cta-hero]');
    if (!heroRoot || heroRoot.dataset.isol8Bound === 'true') return;
    heroRoot.dataset.isol8Bound = 'true';

    const variants = parseVariants(heroRoot.querySelector('[data-isol8-variants-json]'));

    const applyFromValue = (value) => {
      const variant = variants.find((item) => item.option1 === value && item.available)
        || variants.find((item) => item.option1 === value)
        || variants.find((item) => item.available)
        || variants[0];
      if (!variant) return;
      setMainVariantId(variant.id);
      syncVariantButtons(variant);
      updateHeroCta(variant);
      updateClosingCta(variant);
      document.querySelectorAll('.isol8-sticky-atc').forEach((sticky) => updateStickyCta(sticky, variant));
    };

    heroRoot.querySelectorAll('.variant-btn').forEach((btn) => {
      btn.addEventListener('click', () => applyFromValue(btn.dataset.value));
    });

    const active = heroRoot.querySelector('.variant-btn.active');
    if (active) applyFromValue(active.dataset.value);
    else {
      const input = getMainVariantInput();
      const variant = findVariant(variants, input && input.value) || variants.find((item) => item.available) || variants[0];
      updateHeroCta(variant);
      updateClosingCta(variant);
    }
  }

  function initClosingAtc() {
    const variants = getVariantsList();
    document.querySelectorAll('[data-isol8-closing-atc]').forEach((btn) => {
      if (btn.dataset.isol8Bound === 'true') return;
      btn.dataset.isol8Bound = 'true';
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        const currentInput = getMainVariantInput();
        const currentVariant = findVariant(variants, currentInput && currentInput.value)
          || variants.find((item) => item.available)
          || variants[0];
        const target = resolveClosingVariant(btn, variants, currentVariant);
        if (target) {
          setMainVariantId(target.id);
          syncVariantButtons(target);
          updateHeroCta(target);
          document.querySelectorAll('.isol8-sticky-atc').forEach((sticky) => updateStickyCta(sticky, target));
          updateClosingCta(target);
        }
        const submit = getMainSubmit();
        // ISOL8 path: resolved variant available → submit
        if (submit && !submit.disabled && target && target.available) {
          submit.click();
          return;
        }
        // Non-ISOL8 / no variants JSON: still add current form selection to cart
        if (submit && !submit.disabled && !target) {
          submit.click();
          return;
        }
        const hero = document.querySelector('#shopify-section-main, product-info');
        if (hero) hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    const input = getMainVariantInput();
    const current = findVariant(variants, input && input.value)
      || variants.find((item) => item.available)
      || variants[0];
    updateClosingCta(current);
  }

  function initVideoLightboxes() {
    document.querySelectorAll('[data-isol8-video-lightbox]').forEach((trigger) => {
      if (trigger.dataset.isol8Bound === 'true') return;
      trigger.dataset.isol8Bound = 'true';
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const src = trigger.getAttribute('data-isol8-video-lightbox');
        if (!src) return;

        let modal = document.getElementById('Isol8VideoLightbox');
        if (!modal) {
          modal = document.createElement('div');
          modal.id = 'Isol8VideoLightbox';
          modal.className = 'isol8-video-lightbox';
          modal.innerHTML = `
            <div class="isol8-video-lightbox__backdrop" data-isol8-video-close></div>
            <div class="isol8-video-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Product video">
              <button type="button" class="isol8-video-lightbox__close" data-isol8-video-close aria-label="Close">&times;</button>
              <video class="isol8-video-lightbox__video" controls playsinline></video>
            </div>
          `;
          document.body.appendChild(modal);

          if (!document.getElementById('Isol8VideoLightboxStyles')) {
            const style = document.createElement('style');
            style.id = 'Isol8VideoLightboxStyles';
            style.textContent = `
              .isol8-video-lightbox{position:fixed;inset:0;z-index:100;display:none;align-items:center;justify-content:center;padding:20px}
              .isol8-video-lightbox.is-open{display:flex}
              .isol8-video-lightbox__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.72)}
              .isol8-video-lightbox__dialog{position:relative;z-index:1;width:min(960px,100%);background:#000;border-radius:12px;overflow:hidden}
              .isol8-video-lightbox__close{position:absolute;top:8px;right:10px;z-index:2;border:0;background:rgba(0,0,0,.55);color:#fff;width:36px;height:36px;border-radius:999px;font-size:24px;cursor:pointer}
              .isol8-video-lightbox__video{display:block;width:100%;max-height:80vh;background:#000}
            `;
            document.head.appendChild(style);
          }

          modal.addEventListener('click', (clickEvent) => {
            if (clickEvent.target.closest('[data-isol8-video-close]')) {
              const video = modal.querySelector('video');
              if (video) {
                video.pause();
                video.removeAttribute('src');
                video.load();
              }
              modal.classList.remove('is-open');
              document.body.style.overflow = '';
            }
          });
        }

        const video = modal.querySelector('video');
        video.src = src;
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        video.play().catch(() => {});
      });
    });
  }

  function init() {
    initHeroFramework();
    initClosingAtc();
    initVideoLightboxes();
    document.querySelectorAll('.isol8-sticky-atc').forEach(initStickyBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
